export default {
	logoName:'CONTRACTS',
	comboChooseText:'--Таңдау--',
	save :"Сақтау",
	reset:"Қалпына келтіру",
	logOut:'Жүйеден шығу',
	ex:{
		managerNotConfirmed: "Менеджер растамаған",
		operator:"Оператор",
		customer:"Клиент",
		manager:"Менеджер",
		checkOrder:"Тапсырысты тексеру",
		comment:"Пікір",
		changeStatus:"Статусты өзгерту",
		chooseStatus:"Статусты таңдау",
		cancel:"Бас тарту",
		orderList:"Тапсырыстар тізімі",
		orderStatus:"Тапсырыс статусы",
		comments:"Пікірлер",
		managerNotCommented:"Менеджер пікір білдірмеген",
		userFio:"Аты-жөні",
		coin:"Койн",
		perPrice:"Бірлік бағасы",
		count:"Саны",
		sum:"Жалпы",
		date:"Күні",
		actions:"Әрекеттер",
		managerCheck:"Менеджер тексеру",
		confirm:"Растау",
		decline:"Қабылдамау",
		successConfirm:"Сәтті расталды",
		unknownError:"Белгісіз қате",	
		status:"Статус",
		goBack:"Артқа",
		managerNotConfirmed:"Менеджер растамаған",
		organization:"Заңды тұлға",
		privatePerson:"Жеке тұлға", 
		view:"Көру",
		uHaveNoRole:"Сізде рөл жоқ",
		actionSucceed:"Әрекет сәтті аяқталды",
	},
	system:{
		errorTitle:'Қате',
		successTitle:'Жетістік',
		successMsg:"Сәтті аяқталды",
		dublicationMsg:'Жазба қайталанған !!!',
		newRecord:"Жаңа жазба",
		confirmMsg:'Сіз сенімдісіз бе ?',
		selectAll:'Барлығын таңдаңыз',
		unSelectAll:'Барлығын алып тастау',
		status:'Статус',
		beginDate:"Басталу күні",
		endDate:"Аяқталу күні",
		search:"Іздеу",
		loading:"Жүктелуде",
		add:'қосу',
		delete:'жою',
		update:'жаңарту',
		failMsg:"Белгісіз қате анықталды. Қайталап көріңіз.",
		delete:"Жою",
		update:"Жаңарту",
		actions:"Әрекеттер"
	},

	mainMenu: {
		currentLang:'KAZ',
		projects:'келісім-шарттар',

		project:{
			add:"жоба қосу",
			list:"барлық жобалар"
		},
		settings: 'анықтамалық деректер',
		setting:{
			companies:"компаниялар",
			users:"пайдаланушылар",

			
			cats:"санаттар",
			departments:"бөлімдер",
			locations:"",
			level:"жоба деңгейлері",
			budgets:"бюджеттер",
			status:"күй түрлері",
			types:"жоба түрлері",
			roles:"рөлдер"
		},
		graphs :'Графикалық ақпарат',
	},

	//begining of Dag
	pForm:{
		createNew: "Жаңа жоба құру",
		pKm: "Километр",
		pPrice: "Келісім-шарт құны, тенге",
		pAddress: "Мекен-жайы",
		organizations: "Мердігерлік ұйым",
		pNumber: "Келісім-шарт номері",
		pName: "Жоба атауы",
		pDate: "Жобаны құру күні",
		endDate: "Жобаның аяқталатын күні",
		pTopCover: "(Ж,Ж,Қ. км) жабынның жоғарғы қабаты",
		pBottomCover: "(Ж.Т.Қ. км) жабынның төменгі қабаты",
		pMainCover: "тегістеу қабаты / негізі",
	},
	//end of Dag
	prject: {
		levelName: "Жоба түрі",
		locationName: "Обласы",
		pNumber: "Келісім-шарт номері",
		pPrice: "Келісім-шарт құны, тенге",
		pKm: "Километр",
		pDate: "Келісім-шарт құру күні",
		pAddress: "Адрес",
		ortNames: "Мердігерлік ұйым",
		bActions: "Есеп",
		Actions: "Әрекеттер",
	},


	lMenu:{
		courses:"курстар",
		freeCourses:"тегін курстар",
		start:"бастау"
	},
	lms:{
		machineTurnOnError:"an error occured when turning on machines"
	},
	
	deliveryList:{
		deliveryListTitle:"Тапсырыстар тізімі",
		newDelivery: "Жаңа",
		inProgress:"Орындалуда",
		done:"Дайын",
		deepSearch:"Терең іздеу",
		cassReport:"Касс есебі",
		byOrderNumber:"Тапсырыс нөмірі бойынша",
		byNewOrder:"Жаңа тапсырыс бойынша",
		

	},
	orderDate:"Тапсырыс күні",
	orderNumber:"Тапсырыс нөмірі",
	userInfo:"Клиент туралы ақпарат",
	totalProductPrice:"Өнімнің жалпы бағасы",
	takenCostByCash:"Қолма-қол ақшамен",
	takenCostByCard:"Карта арқылы",
	deliveryLoan:"Тапсырыс несиесі",
	showDetails:"Мәліметтерді көрсету",
	updateOrder:"Тапсырысты жаңарту",
	deleteOrder:"Тапсырысты жою",
	noSlicers:"Кесушiлер тандамаган",
	catName:"Өнім санаты",
	colorName:"Өнімнің түсі",
	measureName:"Өлшемі",
	productCount:"Өнім саны",
	doneCount:"Аяқталған саны",
	leftCount:"Аяқталмаған саны",
	productPrice:'Өнімнің бағасы',
	totalPrice:"Жалпы бағасы",
	wareHouseName:"Қойма",
	
	listSlicers:"Кесушілер",
	completed:"Аяқталды",
	unCompleted:"Аяқталмаған",
	orderActions:"Әрекеттер",
	teacherModule:{
		myDocuments : 'Менің құжаттарым',
		newDocument : 'Жаңа құжатты толтыру'
	},
	userPage :{
		userList:'Қолданушылар тізімі'
	},
	wrongFile:"Жүктелуі тиіс файлдың атын ауыстыруыңызды сұраймыз. Файл атауында нүкте немесе с.с. арнайы символдар болмауы тиіс!!!",
	"userList.lastName":"Тегi","userList.firstName":"Аты","userList.email":"Электрондық пошта","userList.phoneNumber":"Телефон нөмірі","userList.role":"Рөлі","userList.userModal":"Жаңа қолданушы тіркеу","system.newButton":"Жаңа","system.updateButton":"Өзгерту","system.deleteButton":"Жою","system.searchText":"Іздеу мәні...","system.recordCountText":"Жазба саны","system.defaultSearch":"Іздеу","userList.userFormTypeText":"Факультет","userList.userForm.password":"құпиясөз","system.submitButtonText":"Сақтау","system.cancelButtonText":"Бас тарту","enu.departmentList.departmentName":"Бөлімнің атауы","enu.departmentList.title":"Бөлім тізімі","enu.userList.mainTitle":"Департамент және қолданушылар","enu.departmentList.departmentNameRu":"Бөлімнің атауы орысша","userList.departmentName":"Бөлім","enu.documentCategory.title":"Көрсеткіш","enu.docCatList.docCatName":"Көрсеткіш атауы","enu.docCatList.docCount":"Көрсетуге болатын саны","enu.docCatList.maxPoint":"Максималды балл","enu.docCatList.insertedDocCount":" Көрсеткіш бөлімдерінің саны","enu.docCatList.docCatNameRu":"Көрсеткіштің атауы (орысша)","enu.docCatList.insertableDocCount":"Құжаттардың максималды саны","enu.documentModule.title":"Құжат модулі","enu.blockForm.blockName":"Блок атауы","enu.blockForm.blockNameRu":"Блоктың атауы рус","enu.blockForm.maxPoint":"Максималды балл","enu.blockList.title":"Блоктар","enu.docCatList.chooseBlock":"Блокты таңдаңыз","enu.documentCategory.blockListName":"Блок","system.error.chooseBlock":"Блокты таңдаңыз","enu.error.wrongPointMsg":"Сіз рұқсат етілгеннен көп балл енгіздіңіз. Мүмкін болатын максималды балл","enu.error.unKnownError":"Қате пайта болды, әрекетті қайталап көріңіз.","enu.documentList.title":"Құжаттар тізімі","enu.docList.docName":"Құжат","enu.docList.chooseDocCat":"Құжат санатын таңдаңыз","enu.docForm.docName":"Құжат атауы","enu.docForm.docNameRu":"Құжаттың орысша атауы","system.error.chooseBlockOrDocCat":"Сіз блок немесе құжат санатын таңдаған жоқсыз","userList.userForm.chooseCatText":"Сарапшы талдай алатын көрсеткіштер","enu.teacherDocList.categoryName":"Санат атауы","enu.teacherDocList.takenPoint":"Сараптаудан кейін","enu.teacherDocForm.shortDescription":"Қысқаша сипаттама (интернет ресурстарға сілтеме, т.б.)","enu.teacherDocForm.shortDescriptionRu":"Орысша қысқаша сипаттама","enu.teacherDocForm.chooseFile":"Файл таңдаңыз немесе тастаңыз ...","enu.teacherDocForm.dropHere":"Файлды мына жерге тастаңыз ...","enu.teacherDocForm.addRow":"+ Қосу","enu.teacherDocForm.rowWarnMsg":"Сіз көрсеткіш категориясы бойынша енгізуге мүмкін құжат санын асырдыңыз.","enu.teacherDocForm.fillAllError":"Барлық ақпаратты енгізіңіз.","enu.teacherDocForm.noFileError":"Файлды таңдаңыз.","enu.docCatForm.chooseIsTeam":"Ортақ көрсеткіш","enu.teacherForm.networkOrFileError":"Желі қателігі орын алды немесе сіз үлкен файлды таңдадыңыз","enu.teacherForm.incorrectFileError":"Сіз қате файл жүктеп салдыңыз","enu.teacherForm.docCountInformationMsg":"Назар аударыңыз, енгізілетін құжаттар саны шектеулі","enu.teacherForm.allowedUploadSizeMsg":"Рұқсат етілген жүктеу мөлшері","enu.teacherForm.uploadedSizeMsg":"Жүктелген құжаттар саны","enu.teacherForm.teamInputMsg":"Авторлар саны","enu.teacherDocList.plannedPoint":"Мүмкін ұпай","enu.teacherDocListSunDocCatListTitle":"Құжат санаттары","enu.system.closeSubCategory":"Жинау","enu.system.closeSubDocument":"Жинау","enu.landing.mainMenu.top100":"ЖОО ҮЗДІК ҰСТАЗЫ","enu.landing.copyrightText":"© Л.Н.Гумилев атындағы Еуразия ұлттық университеті","enu.landing.departmentsText":"Бөлімдер","enu.landing.teacherForm.workPosition":"Лауазымы","enu.landing.teacherForm.dateOfBirth":"Туған күні, айы, жылы","enu.landing.teacherForm.dateOfPositionShort":"Жұмыс өтілі","enu.landing.teacherForm.education":"Білімі (қай оқу орны, факультет, қай жылы бітірді)","enu.landing.teacherForm.degree":"Ғылыми дәрежесі / атағы","enu.landing.teacherForm.adress":"Тұрақты мекен-жайы (индекспен)","enu.landing.teacherForm.regNumber":"ЖСН","enu.landing.teacherForm.prise":"Марапаттаулары","system.loginTxt":"Кіру","system.regTxt":"Тіркелу","system.login.userName":"e-mail","system.login.userPassword":"Құпиясөз","enu.teacherForm.isFifteen1":"15 жылдан көп","enu.teacherForm.isFifteen2":"15 жылға дейін","enu.teacherForm.missingDepartmentMsg":"Бөлімді таңдаңыз.","enu.teacherForm.notSamePasswordMsg":"Сіз бірдей емес құпиясөздерді енгіздіңіз.","enu.teacherForm.reEnterPassword":"Құпиясөзді қайта енгізіңіз.","enu.system.contactUsTxt":"Байланыс","enu.teacherForm.thirdName":"Әкесінің аты","enu.teacherForm.idCardGroupTxt":"Жеке куәлік мәліметтері","enu.teacherForm.idCardNumberTxt":"Нөмірі","enu.teacherForm.IdCardDateTxt":"Берілген күні","enu.teacherForm.GivenOrgTxt":"Берген орган","enu.teacherForm.givenOrg1":"ҚР ІІМ","enu.teacherForm.givenOrg2":"ҚР ӘМ","enu.teacherForm.givenOrgChooseText":"Берген органды таңдаңыз","enu.teacherForm.missingPositionTxt":"Лауазымын көрсетіңіз","enu.teacherForm.missingDegreeTxt":"Ғылыми атағын көрсетіңіз","enu.teacherForm.missingDateOfBirthTxt":"Туған күніңізді көрсетіңіз","enu.teacherForm.missingIdCardDateTxt":"Жеке куәліктің берілген күнін көрсетіңіз","enu.teacherForm.wrongInTxt":"ЖСН дұрыс емес","enu.teacherForm.wrongIdCardTxt":"Жеке куәліктің нөмірі дұрыс емес","enu.teacherDocList.docActions":"Әрекеттер","enu.teacherDocList.downloadDocument":"Жүктеу","enu.teacherDocList.fillMenuName":"enu.teacherDocList.fillMenuName","enu.teacherDocList.yearPlanning":"Жылдың жоспары","enu.teacherDocList.fillDocTheadWork":"Жұмыс түрлерінің атауы","enu.teacherDocList.fillDocTheadMeasure":"Өлшем бірлігі","enu.teacherDocList.fillDocTheadDependency":"Көрсетілген жұмыс түрін іске асыруға негіздеме (болжамды атауы көрсетілген)","enu.teacherDocList.fillDocDateTitle":"Орындау мерзімі","enu.teacherDocList.fillDocBeginDate":"басталуы","enu.teacherDocList.fillDocEndDate":"аяқталуы","enu.teacherDocList.fillDocOfficialTitle":"Қазақстан Республикасы Білім және ғылым министрі міндетін атқарушының\r\n2015 жылғы 16 наурыздағы № 124 бұйрығымен бекітілген\r\n«Жоғары оқу орнының үздік оқытушысы» атағын беру қағидаларына 3-қосымша\r\n","enu.teacherDocList.fillDocH1Title":"Жұмыстардың жылдық жоспар-кестесі","enu.teacherDocList.FillDocCategoryError":"Жоғарыдағы жұмыс санатында кем дегенде бір толтырылған жұмыс болуы керек.","enu.teacherDocList.FillDocDocError":"Жоғарыдағы жұмыс толтырылуы керек.","enu.teacherDocList.FillDocSignature":"Байқауға қатысушы","enu.teacherDocList.FillDocPrint":"Басып шығару",
	lms:{
		login:"Жүйеге кіру",
		register:"Жүйеге тіркелу",
		userList:{
			systemUsers:'Жүйе пайдаланушылары',
			firstName:'Аты',
			lastName:'Тек',
			userName:'Логин аты',
			phoneNumber:'Телефон нөмірі',
			role :'Жүйедегі рөлі',
			blocking:"Блоктау",
			unblocking:"Блоктан шығару",
			enroll:"Тіркелу"
		},
		
		userForm:{
			modalTitle:"Пайдаланушы ақпараты",
			userType:"Пайдаланушы түрі",
			thirdName:"Әкесінің аты",
			lastName:"Тек",
			firstName:"Аты",
			phoneNumber:"Телефон нөмірі",
			email:"Электрондық пошта",
			password:"Құпия сөз",
			repeatPassword:"Құпия сөзді қайталаңыз",
			addUser:"Пайдаланушы қосу",
			clear:"Тазалау",
			roleConfirm:"Пайдаланушы түрін таңдау керек",
			passwordsNotMatchError:"Сіз енгізген құпия сөздер бірдей емес!!!",
			dublicatedEmail:"Электрондық пошта бұрыннан тіркелген!!!",
			wrongLogin:"Электрондық пошта немесе құпия сөз дұрыс емес.",
			blockedUser:"Сіз блокталған пайдаланушысыз. Жүйе әкімшісіне хабарласыңыз"
		},
		
		
		courseList:{
			mainTitle:"Курс пен модульді басқару",
			courseList:"Курс тізімі",
			courseName:"Аты",
			moduleCount:"Модульдер",
			courseCount:"Курстар",
			studentCount:"Студенттер",
			status:"Күй",
			delete:"Жою",
			active:"Белсенді",
			inActive:"Белсенді емес",
			newCourse:"Жаңа курс [+]",
			moduleName:"Модуль",
			lectureCount:"Лекция",
			labCount:"Лабротория",

			//new things
			yes:"Иә",
			no:"Жоқ",
			isFree:"Курс тегін бе, жоқ па",
			description:"Сипаттама",
			delete:"жою",
			introduction:"Курсқа кіріспе",
			isDefault:"Негізгі,негізгі емес",
			buildIntro:"Курстың кіріспесін құрастыру"

			
		},
		courseForm:{
			chooseFile:"Файлды таңдаңыз ...",
			dropFile:"Файлды осы жерге тастаңыз..."
		},

		moduleList:{
			moduleFiles:"Модуль бөліктері",
			create:"Модуль бөліктерін құрастыру",
			createModule:"Модуль жасау"
		},
		moduleForm:{
			modalTitle:"Курсты құру және жаңарту",
			chooseCourses:"Модульді қамтитын курстарды таңдаңыз"
		},
		serverList:{
			mainTitle:"Лабротория құруға арналған серверлер",
			serverName:"Сервер атауы",
			ipAddress:"Сервер IP",
			description:"Сипаттама",
			imagePath:"Логотип",
			createServer:"Сервер құру",
			userName:"Сервер пайдаланушы аты",
			password:"Сервер құпия сөзі",
			protocol:"Сервер протоколы",
			hasPublicIp:"Серверде сыртқы IP бар ма ?",
			ami:"AMI",
			ipMask:"IPMASK",
			instanceType:"Instance type"
		},
		labList:{
			mainTitle:"Әр модуль үшін лаброториялар",
			chooseServers:"Лабротория үшін пайдаланылатын серверлерді таңдаңыз",
			labName:"Лабротория атауы",
			labText:"Лабротория сипаттама",
			labEmbedded:"Лабротория бейне сабақ",
			chooseScorm:"Лаброторияға арналған SCORM файлы",
			labFiles:"Қосылған бөліктер",
			createLab:"Лабротория құру",
			servers:"Серверлер",

			isLecture:"Лекция ма, жоқ па?",
			lectureList:"Лекциялар",
			createLecture:"Дәріс құру",
			lectureName:"Лекция атауы",
			lectureText:"Лекция сипаттама",
			addToModule:"Модульге қосу"

		},
		videoList:{
			mainTitle:"Бейне тізімі",
			name:"Аты",
			description:"Сипаттама",
			showVideo:"Көру",
			videoPath:"Бейне коды",
			bottomText:"Бейнероликтің кіріспе мәтіні",
			createVideo:"Жаңа бейне жасау"
		},
		catList:{
			createCat:"Санат жасау",
			catName : "Санат атауы"
		},
		add:"Жазба қосу",
		clear:"Тазалау",
		chooseImage:"Суретті таңдаңыз.",
		detailSuccess:"Компонент сәтті жасалды.",
		image:"Фото компонент",
		scorm:"Scorm компоненті",
		video:"Бейне компоненті",
		text:"Мәтіндік компонент",
		command:"Code, command",
		detailComps:"Құрамдас бөліктер",
		courseCategory:"Курс санаты [+]",
		chooseCats:"Санаттарды таңдаңыз",
		isDefault:"Лекция негізгі бола ма?",
		vps:{
			manageVps:"VPS басқару",
			vpsName:"VPS атауы",
			manageVps:"Server vpses",
			chooseVpses:"VPS таңдаңыз"
		},
		myCourses:"Менің курстарым",
		mustLoginError:"Курсты көру үшін жүйеге кіру керек!!!",
		selectCourses:"Курстарды таңдау."
		
	}
};